<template>
      <div class="relative flex items-start justify-between w-full gap-x-2 p-4 md:pb-10 pb-20 text-gray-500 mt-10" v-if="showFooter">
      <div class="flex flex-col text-gray-500 ">
        <div class="md:hidden">
      <p class="font-semibold text-[40px] leading-[48px] whitespace-nowrap mb-1 text-[#528A7C] font-rubik">Built for</p>
      <p class="font-semibold text-[40px] leading-[48px] whitespace-nowrap mb-2 text-[#528A7C] font-rubik">digital India</p>
      </div>
      <p class="hidden md:block font-semibold text-[60px] leading-[48px] text-[#528A7C] font-rubik whitespace-nowrap mb-2">
  Built For Digital India
</p>
      <p class="font-semibold mb-2 text-[16px] md:text-[18px] text-[#0C5542] md:mb-[40px]">Trusted by over 34,50,000 Indians</p>
      <div class="flex flex-col md:flex-row gap-y-2 md:gap-x-8">
        <div class="flex items-center gap-x-2">
          <p class="text-[19px] font-semibold">Powered by</p>
          <NuxtImg src="https://newdelhi.ad-tech.com/wp-content/uploads/2021/11/ONDC_logo.png" alt="ONDC" title="ONDC" class="h-8 w-16" />
        </div>
        <div class="flex items-center gap-x-2">
          <p class="text-[19px] font-semibold">Built by</p>
          <NuxtImg src="https://cdn.prod.website-files.com/676e392bc4060ff4a69a8564/6789de90c979207262a0879b_677a5201115e12eff6bf50a9_nStore%20001%202%20(1).png" alt="NSTORE" title="NSTORE" class="h-4 w-16" />
        </div>
          <div class="absolute bottom-[-10px] pb-4 md:bottom-0 right-0 w-[148px] h-[124px] md:w-[274px] md:h-[231px] pointer-events-none">
  <NuxtImg
    src="/v2/images/shopping.png"
    alt="Shopping"
    title="Shopping"
    class="w-full h-full object-contain"
    style="transform: rotate(0deg);" 
  />
</div>
      </div>
    </div>
    <!-- <div class="flex self-end md:self-center pr-4 pb-4 md:pr-12 md:pb-0">
      <UIcon name="fluent:wallet-credit-card-48-filled" class="h-24 w-24 md:h-48 md:w-48 text-gray-400"/>
    </div> -->
  </div>
</template>
<script setup>
const route = useRoute();
const { cartItems } = useCartSummary(); 
const showFooter = computed(() => {
  return route.path !== '/cart' || cartItems.value.length !== 0;
});

</script>